export default __webpack_public_path__ + "static/media/ET.736517b2.svg";